/**
 * @generated SignedSource<<0003c9a466bde83ddcc97d7f8be8ba8f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "accountId",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "biId",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "BusinessIdentityCreateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "CreateBusinessIdentityTPayload",
        "kind": "LinkedField",
        "name": "createBusinessIdentityT",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "BusinessIdentityT",
            "kind": "LinkedField",
            "name": "businessIdentityT",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "BusinessIdentityCreateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "CreateBusinessIdentityTPayload",
        "kind": "LinkedField",
        "name": "createBusinessIdentityT",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "BusinessIdentityT",
            "kind": "LinkedField",
            "name": "businessIdentityT",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "nodeId",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "b11550fa7c2c1c4d2ed9537e9aa61178",
    "id": null,
    "metadata": {},
    "name": "BusinessIdentityCreateMutation",
    "operationKind": "mutation",
    "text": "mutation BusinessIdentityCreateMutation(\n  $input: CreateBusinessIdentityTInput!\n) {\n  createBusinessIdentityT(input: $input) {\n    businessIdentityT {\n      accountId\n      biId\n      nodeId\n    }\n  }\n}\n"
  }
};
})();

node.hash = "32f4f8f50887475e6831a9acbc627efd";

module.exports = node;
